import type {
  CreateJobProfileDto,
  JobProfileDto,
  JobProfileSummaryDto,
  UpdateJobProfileDto,
} from "@reactive-resume/dto";

import { axios } from "@/client/libs/axios";

export const fetchJobProfiles = async () => {
  const response = await axios.get<JobProfileSummaryDto[]>("/job-profiles");
  return response.data;
};

export const fetchJobProfile = async (id: string) => {
  const response = await axios.get<JobProfileDto>(`/job-profiles/${id}`);
  return response.data;
};

export const createJobProfile = async (data: CreateJobProfileDto) => {
  const response = await axios.post<JobProfileDto>("/job-profiles", data);
  return response.data;
};

export const updateJobProfile = async (id: string, data: UpdateJobProfileDto) => {
  const response = await axios.patch<JobProfileDto>(`/job-profiles/${id}`, data);
  return response.data;
};

export const deleteJobProfile = async (id: string) => {
  await axios.delete(`/job-profiles/${id}`);
};
